import {ReportModel} from "@fedeltapointofsale/data-client";
import {AccItemStmtReportData} from "./acc-item-stmt-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class AccItemStmtReportModel extends ReportModel<AccItemStmtReportData> {
    constructor(injector: Injector) {
        super(injector, AccItemStmtReportData);
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
